(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('SecurityController', security);
  security.$inject = ['$rootScope', 'CompanyService', 'NotificationService'];
  function security ($rootScope, CompanyService, NotificationService) {
    var vmSecurity = this;

    $rootScope.getPageLabels('menu.config.securitySett');

    // Functons
    vmSecurity.loadMetadata = loadMetadata;
    vmSecurity.validateNumber = validateNumber;
    vmSecurity.saveLoginAttempts = saveLoginAttempts;
    vmSecurity.savePasswordPattern = savePasswordPattern;
    vmSecurity.savePasswordChange = savePasswordChange;
    vmSecurity.saveLoginAttemptsMetadata = saveLoginAttemptsMetadata;
    vmSecurity.savePasswordPatternMetadata = savePasswordPatternMetadata;
    vmSecurity.savePasswordChangeMetadata = savePasswordChangeMetadata;
    vmSecurity.changeLoginAttempts = changeLoginAttempts;
    vmSecurity.changePasswordPattern = changePasswordPattern;
    vmSecurity.changePasswordChange = changePasswordChange;
    vmSecurity.changeInactivityLock = changeInactivityLock;
    vmSecurity.saveInactivityLock = saveInactivityLock;

    loadMetadata();

    function loadMetadata () {
      CompanyService
        .loadMetadata()
        .$promise
        .then(function (data) {
          vmSecurity.metadata = data;
          vmSecurity.metadata['SLA'] = { 'security_login_attempts': data.security_login_attempts };
          vmSecurity.metadata['SPP'] = { 'security_password_pattern': data.security_password_pattern };
          vmSecurity.metadata['SPC'] = { 'security_password_change': data.security_password_change };
          vmSecurity.metadata['SIL'] = { 'security_inactivity_lock': data.security_inactivity_lock };
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorMetadata);
        });
    }

    function validateNumber (data) {
      if (isNaN(data)) {
        NotificationService.warningHandler(null, $rootScope.labels.validateNumber);
        return false;
      }
      return true;
    }

    function saveLoginAttemptsMetadata () {
      CompanyService
        .saveMetadata(vmSecurity.metadata.SLA)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.configSaved);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorSaveConfig);
        });
    }

    function savePasswordPatternMetadata () {
      CompanyService
        .saveMetadata(vmSecurity.metadata.SPP)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.configSaved);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorSaveConfig);
        });
    }

    function savePasswordChangeMetadata () {
      CompanyService
        .saveMetadata(vmSecurity.metadata.SPC)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.configSaved);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorSaveConfig);
        });
    }

    function saveInactivityLockMetada () {
      CompanyService
        .saveMetadata(vmSecurity.metadata.SIL)
        .$promise
        .then(data => {
          $rootScope.company_metadata = data
          NotificationService.successHandler(data, $rootScope.labels.configSaved)
        })
        .catch(data => {
          NotificationService.errorHandler(data, $rootScope.labels.errorSaveConfig)
        })
    }

    function saveLoginAttempts () {
      if (!vmSecurity.metadata.SLA.security_login_attempts.attempts) {
        NotificationService.warningHandler(null, $rootScope.labels.requiredAttempts);
        return;
      }

      if (vmSecurity.metadata.SLA.security_login_attempts.attempts <= 0) {
        NotificationService.warningHandler(null, $rootScope.labels.invalidAttempts);
        return;
      }

      if (validateNumber(document.getElementById('attempts').value)) {
        saveLoginAttemptsMetadata();
      }
    }

    function savePasswordPattern () {
      if (vmSecurity.metadata.SPP.security_password_pattern.allow_min_size && !vmSecurity.metadata.SPP.security_password_pattern.min_size) {
        NotificationService.warningHandler(null, $rootScope.labels.requiredMinSize);
        return;
      }

      if (vmSecurity.metadata.SPP.security_password_pattern.min_size <= 0) {
        NotificationService.warningHandler(null, $rootScope.labels.invalidMinSize);
        return;
      }

      if (document.getElementById('min_size')) {
        if (validateNumber(document.getElementById('min_size').value)) {
          savePasswordPatternMetadata();
        }
      } else {
        savePasswordPatternMetadata();
      }
    }

    function savePasswordChange () {
      if (!vmSecurity.metadata.SPC.security_password_change.days) {
        NotificationService.warningHandler(null, $rootScope.labels.requiredPassChange);
        return;
      }

      if (vmSecurity.metadata.SPC.security_password_change.days <= 0) {
        NotificationService.warningHandler(null, $rootScope.labels.invalidDays);
        return;
      }

      if (validateNumber(document.getElementById('days').value)) {
        savePasswordChangeMetadata();
      }
    }

    function saveInactivityLock () {
      if (!vmSecurity.metadata.SIL.security_inactivity_lock.days) {
        NotificationService.warningHandler(null, $rootScope.labels.requiredInactivityLockDays)
        return
      }

      if (vmSecurity.metadata.SIL.security_inactivity_lock.days <= 0) {
        NotificationService.warningHandler(null, $rootScope.labels.invalidDays);
        return;
      }

      if (validateNumber(document.getElementById('inactivity_days').value)) {
        saveInactivityLockMetada();
      }
    }

    function changeLoginAttempts () {
      if (vmSecurity.metadata.SLA.security_login_attempts.allow) {
        vmSecurity.metadata.SLA.security_login_attempts.allow = true;
      } else {
        vmSecurity.metadata.SLA.security_login_attempts.attempts = null;
        saveLoginAttemptsMetadata();
      }
    }

    function changePasswordPattern () {
      if (vmSecurity.metadata.SPP.security_password_pattern.allow) {
        vmSecurity.metadata.SPP.security_password_pattern.allow = true;
      } else {
        vmSecurity.metadata.SPP.security_password_pattern.letters = false;
        vmSecurity.metadata.SPP.security_password_pattern.numbers = false;
        vmSecurity.metadata.SPP.security_password_pattern.unicode = false;
        vmSecurity.metadata.SPP.security_password_pattern.allow_min_size = false;
        vmSecurity.metadata.SPP.security_password_pattern.min_size = null;
        savePasswordPatternMetadata();
      }

      if (vmSecurity.metadata.SPP.security_password_pattern.allow_min_size) {
        vmSecurity.metadata.SPP.security_password_pattern.allow_min_size = true;
      } else {
        vmSecurity.metadata.SPP.security_password_pattern.min_size = null;
      }
    }

    function changePasswordChange () {
      if (vmSecurity.metadata.SPC.security_password_change.allow) {
        vmSecurity.metadata.SPC.security_password_change.allow = true;
      } else {
        vmSecurity.metadata.SPC.security_password_change.days = null;
        savePasswordChangeMetadata();
      }
    }

    function changeInactivityLock () {
      if (vmSecurity.metadata.SIL.security_inactivity_lock.allow) {
        vmSecurity.metadata.SIL.security_inactivity_lock.allow = true
      } else {
        vmSecurity.metadata.SIL.security_inactivity_lock.allow = null
        saveInactivityLockMetada()
      }
    }
  }
})();
